module.exports = {
	"id": "ZM",
	"name": "Zambia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.002442,
			"11": 0.026862,
			"12": 0.002442,
			"13": null,
			"14": null,
			"15": 0.001221,
			"16": 0.001221,
			"17": null,
			"18": 0.006105,
			"19": 0.002442,
			"20": null,
			"21": 0.006105,
			"22": 0.001221,
			"23": 0.001221,
			"24": null,
			"25": 0.006105,
			"26": 0.021978,
			"27": 0.002442,
			"28": 0.004884,
			"29": 0.003663,
			"30": 0.002442,
			"31": 0.018315,
			"32": 0.004884,
			"33": 0.008547,
			"34": 0.003663,
			"35": 0.003663,
			"36": 0.006105,
			"37": 0.002442,
			"38": 0.006105,
			"39": 0.013431,
			"40": 0.015873,
			"41": 0.002442,
			"42": 0.010989,
			"43": 0.081807,
			"44": 0.009768,
			"45": 0.047619,
			"46": 0.010989,
			"47": 0.018315,
			"48": 0.023199,
			"49": 0.107448,
			"50": 0.046398,
			"51": 0.162393,
			"52": 0.118437,
			"53": 3.069594,
			"54": 0.714285,
			"55": 0.015873,
			"56": 0.006105,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.021978,
			"4": 0.009768,
			"5": 0.007326,
			"6": 0.003663,
			"7": 0.003663,
			"8": 0.004884,
			"9": 0.006105,
			"10": 0.008547,
			"11": 0.008547,
			"12": 0.021978,
			"13": 0.009768,
			"14": 0.008547,
			"15": 0.021978,
			"16": 0.01221,
			"17": 0.009768,
			"18": 0.009768,
			"19": 0.018315,
			"20": 0.01221,
			"21": 0.01221,
			"22": 0.009768,
			"23": 0.004884,
			"24": 0.004884,
			"25": 0.010989,
			"26": 0.010989,
			"27": 0.009768,
			"28": 0.006105,
			"29": 0.019536,
			"30": 0.013431,
			"31": 0.009768,
			"32": 0.008547,
			"33": 0.013431,
			"34": 0.01221,
			"35": 0.014652,
			"36": 0.014652,
			"37": 0.019536,
			"38": 0.026862,
			"39": 0.032967,
			"40": 0.02442,
			"41": 0.021978,
			"42": 0.014652,
			"43": 0.152625,
			"44": 0.063492,
			"45": 0.047619,
			"46": 0.035409,
			"47": 0.284493,
			"48": 0.304029,
			"49": 1.449327,
			"50": 0.194139,
			"51": 0.001221,
			"52": 0.002442,
			"3.5": 0.008547,
			"3.6": 0.017094
		},
		"opera": {
			"9": null,
			"11": 0.004884,
			"12": 0.013431,
			"15": 0.002442,
			"16": null,
			"17": 0.006105,
			"18": 0.002442,
			"19": null,
			"20": 0.003663,
			"21": 0.002442,
			"22": 0.002442,
			"23": 0.001221,
			"24": null,
			"25": null,
			"26": 0.003663,
			"27": null,
			"28": 0.004884,
			"29": 0.006105,
			"30": 0.004884,
			"31": 0.003663,
			"32": 0.002442,
			"33": 0.002442,
			"34": 0.017094,
			"35": 0.015873,
			"36": 0.032967,
			"37": 0.111111,
			"38": 0.017094,
			"39": 0.03663,
			"40": 0.583638,
			"41": 0.040293,
			"42": null,
			"43": null,
			"9.5-9.6": 0.003663,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.003663,
			"11.1": 0.004884,
			"11.5": 0.003663,
			"11.6": 0.020757,
			"12.1": 0.017094
		},
		"safari": {
			"0": null,
			"4": 0.003663,
			"5": 0.006105,
			"6": 0.001221,
			"7": 0.008547,
			"8": 0.025641,
			"9": 0.018315,
			"10": 0.124542,
			"3.1": null,
			"3.2": null,
			"5.1": 0.023199,
			"6.1": 0.008547,
			"7.1": 0.01221,
			"9.1": 0.098901
		},
		"ios_saf": {
			"8": 0,
			"10": 0.546118125729,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0147172515612,
			"8.1-8.4": 0.027189498647,
			"9.0-9.2": 0.0129711369692,
			"9.3": 0.197892987094
		},
		"android": {
			"3": 0,
			"4": 0.0600238604651,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00750298255814,
			"4.1": 0.216514639535,
			"4.2-4.3": 0.541286598837,
			"4.4": 1.24120768605,
			"4.4.3-4.4.4": 1.25192623256
		},
		"ie": {
			"6": 0.00621260204082,
			"7": 0.00745512244898,
			"8": 0.247261561224,
			"9": 0.0994016326531,
			"10": 0.131707163265,
			"11": 0.847398918367,
			"5.5": null
		},
		"op_mob": {
			"0": 4.56246819906,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.126735227752
		},
		"edge": {
			"12": 0.13431,
			"13": 0.188034,
			"14": 0.144078
		},
		"ie_mob": {
			"10": 0.344483014085,
			"11": 1.40253798592
		},
		"bb": {
			"7": 0.20411175,
			"10": null
		},
		"samsung": {
			"0": 1.334408
		},
		"and_uc": {
			"0": 7.128548
		},
		"op_mini": {
			"0": 61.4693405732
		},
		"and_chr": {
			"0": 6.048547
		},
		"and_ff": {
			"0": 0.017558
		}
	},
	"total": 97.56560175
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ZM.json
 ** module id = 687
 ** module chunks = 0
 **/